const VUE_APP_API_PONTUS_URL = document.querySelector("html").getAttribute("api_pontus_url");

export default VUE_APP_API_PONTUS_URL


// WEBPACK FOOTER //
// ./src/util/getapi/pontus.js